import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bb1b572"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-leading-[114px] tw-pb-[43px] md:tw-pb-0 md:tw-leading-[28px] md:tw-flex md:tw-justify-center md:tw-space-x-8 lg:tw-space-x-16 xl:tw-space-x-32" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "tw-relative tw-top-0 tw-left-0" }
const _hoisted_6 = { class: "submenu md:tw-absolute md:tw-top-[44px] md:tw-left-[-20px] md:tw-z-20 md:tw-border-t-solid md:tw-border-t-4 md:tw-border-t-primary" }
const _hoisted_7 = {
  key: 0,
  class: "tw-origin-top tw-leading-[67px] md:tw-text-nowrap md:tw-leading-10 tw-px-8 tw-py-4 md:tw-border-solid md:tw-border-x-4 md:tw-border-b-4 md:tw-border-primary md:tw-rounded-b-3xl tw-bg-mainbg1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ContactLink = _resolveComponent("ContactLink")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_ctx.$currentUser.value)
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createVNode(_component_SfRouterLink, { to: "/dashboard" }, {
            default: _withCtx(() => [
              _createTextVNode("Dashboard")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasSpellingAccess)
      ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
          (_ctx.isStudent)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: "/dashboard"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Spelling")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_RouterLink, {
                key: 1,
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Spelling")
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasMathsAccess)
      ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
          (_ctx.isStudent || _ctx.isIndividual)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: "/dashboard/maths"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Maths ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_RouterLink, {
                key: 1,
                to: "/maths"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Maths")
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("li", null, [
      _createVNode(_component_SfRouterLink, { to: "/about" }, {
        default: _withCtx(() => [
          _createTextVNode("About")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_ContactLink, { label: "Contact" })
    ]),
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        href: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showFaq && _ctx.showFaq(...args)), ["prevent"]))
      }, "FAQs")
    ]),
    _createElementVNode("li", _hoisted_5, [
      _createElementVNode("a", {
        href: "",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showColorsMenu && _ctx.showColorsMenu(...args)), ["prevent"]))
      }, "Site Colours"),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_Transition, {
          name: "scale",
          onAfterEnter: _ctx.enableHidingColorsMenu
        }, {
          default: _withCtx(() => [
            (_ctx.colorsMenuVisible)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.switchColors('normal')), ["prevent"]))
                    }, "Normal")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.switchColors('hc')), ["prevent"]))
                    }, "High contrast")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.switchColors('dl')), ["prevent"]))
                    }, "Dyslexia Friendly")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onAfterEnter"])
      ])
    ])
  ]))
}